/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OnboardCustomerCommand { 
    azureAdUpn?: string | null;
    diets?: Array<number> | null;
    allergens?: Array<number> | null;
    condiments?: Array<string> | null;
}

